module.exports = __webpack_public_path__ + "img/p4.a73ea904.png";